//
//
//
//
//
//
//
//
//

import DocumentContent from '~/components/other/DocumentContent'
import Preloader from '~/components/other/Preloader'
import { getContentByCode } from '~/utils/utils';
export default {
  components: {
    DocumentContent,
    Preloader
  },
  data() {
    return {
      seo: {}
    }
  },
  methods: {
    getContent(code) {
      return getContentByCode(this.getTextBlocks.data.data, code)
    }
  },
  head() {
    const seo = this.getSeo?.data?.data || {}
    let title = seo.title
    if (title) {
      title = title.replace(/&quot;/g, '"').replace(/&lsquo;/g, '‘').replace(/&laquo;/g, '«').replace(/&raquo;/g, '»')
    }

    return {
      title: title,
      meta: [
        { hid: 'og:title', name: 'og:title', content: title },
        { hid: 'description', name: 'description', content: seo.description },
        { hid: 'og:description', name: 'og:description', content: seo.description },
        { hid: 'keywords', name: 'keywords', content: seo.keywords }
      ]
    }
  },
  chimera: {
    getSeo () {
      return {
        url: `/api/v1/seo/getByCode`,
        key: `page-seo-termsOfUse`,
        params: {
          code: 'termsOfUse',
          lang: this.$i18n.locale || 'ru'
        }
      }
    },
    getTextBlocks () {
      return {
        url: '/api/v1/textBlocks/get/',
        key: 'terms-use-content',
        auto: true,
        params: {
          code: ['terms-use-title', 'terms-use-content'],
          lang: this.$i18n.locale || 'ru'
        }
      }
    }
  }
}
